
import { defineComponent } from "vue";
import DiamondShapeSelect from "@/components/DiamandShapeSelect.vue";
import CaratSelect from "@/components/CaratSlect.vue";
import DiamondList from "@/components/DiamondList.vue";
import AddToCartButton from "@/components/ring-band-configurator/AddToCartButton.vue";
import GiaCertificate from "@/components/diamond-product-page/GiaCertificate.vue";
import DiamondInfoModal from "./components/ring-band-configurator/DiamondInfoModal.vue";
import TotalPrice from "./components/ring-band-configurator/TotalPrice.vue";
import SelectionSummary from "./components/ring-band-configurator/SelectionSummary.vue";
import PriceSelect from "./components/PriceSelect.vue";
import StockAndShippingInfo from "@/components/StockAndShippingInfo.vue";

export default defineComponent({
    name: "App",
    components: {
        StockAndShippingInfo,
        DiamondShapeSelect,
        CaratSelect,
        DiamondList,
        AddToCartButton,
        DiamondInfoModal,
        TotalPrice,
        SelectionSummary,
        PriceSelect
    }
});
